import { Component, OnInit } from '@angular/core';
import { TransportAssocService } from 'app/services/transport-assoc.service';
import { AuthWebService } from 'app/services/authweb.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DialogService } from 'ng2-bootstrap-modal';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AlertComponent } from 'app/popup/alert.component';
import { ToastrService } from 'ngx-toastr';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';
import { SearchCountryField, TooltipLabel, CountryISO } from 'app/shared/projects/ngx-intl-tel-input/src/public_api';

@Component({
  selector: 'app-transport-association',
  templateUrl: './transport-association.component.html',
  styleUrls: ['./transport-association.component.scss']
})
export class TransportAssociationComponent implements OnInit {

  form;
  transportData: any = {};
  sub: any;
  lblHeading = '';
  btnActionLabel = '';
  isEdit: boolean;  
  isDup = false;  
  selectedGroupCode: any = {};
  selectedDisplay = 3;
  message = null;
  now = new Date();
  audit = { created: '', updated: '' };
  user = { LastName: '' };
  mobnumPattern = /^\+?(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;


  //SADC Countries
separateDialCode = true;
SearchCountryField = SearchCountryField;
TooltipLabel = TooltipLabel;
CountryISO = CountryISO;
defaultCountry:any = CountryISO.SouthAfrica;
defaultCountryPhone:any = CountryISO.SouthAfrica;
preferredCountries: CountryISO[] = [
  CountryISO.Angola,
   CountryISO.Botswana,
   CountryISO.Comoros,
   CountryISO.CongoDRCJamhuriYaKidemokrasiaYaKongo,
   CountryISO.Lesotho,
   CountryISO.Madagascar,
   CountryISO.Malawi,
   CountryISO.Mauritius,
   CountryISO.Mozambique,
   CountryISO.Namibia,
   CountryISO.Seychelles,
   CountryISO.Swaziland,
   CountryISO.Zambia,
   CountryISO.Zimbabwe,
  ];


  
  public isLoading = false;

  constructor(private service: TransportAssocService, private authWebService: AuthWebService,
    private router: Router,private toastService:ToastNotificationService,
    private route: ActivatedRoute,
     public utility: UtilityServiceService,private toastr: ToastrService) { }

   ngOnInit() {

     this.initForm();    
    this.onChanges();
    this.user.LastName = (this.authWebService.userData) ? this.authWebService.userData.User.LastName : '';
    this.sub = this.route.params.subscribe(params => {
      if (this.router.url.indexOf('edit') != -1) {
        this.isEdit = true;
        this.lblHeading = 'Edit Transport Association';
        this.btnActionLabel = 'Update';
        const id = +params['id'];
        this.isLoading = true;
        this.service.getById(id).subscribe(result => {
          this.transportData = result;
          this.isLoading = false;
          (<FormGroup>this.form)
            .setValue({
              id: this.transportData.id
              , code: this.transportData.code
              , description: this.transportData.description
              , group_code: this.transportData.group_code
              , sort_order: this.transportData.sort_order
              , is_active: this.transportData.is_active
              , display_ind: this.transportData.display_ind
              , date_created: this.transportData.date_created
              , date_modified: this.transportData.date_modified
              , user_created: this.transportData.user_created
              , user_modified: this.transportData.user_modified
              , email: this.transportData.email
              , cellphone: this.transportData.cellphone
              , telephone: this.transportData.telephone
              , alternative_cellphone: this.transportData.alternative_cellphone
              , alternative_email: this.transportData.alternative_email
             //,fax:this.transportData.fax
            }, { onlySelf: true });
          this.audit = this.utility.setAuditAttributes(this.transportData.date_created, this.transportData.user_created, this.transportData.date_modified, this.transportData.user_modified);
          this.defaultCountry = this.transportData.iso2_cell;
          this.defaultCountryPhone = this.transportData.iso2_tele;
        });
      } else {
        this.isEdit = false;
        this.lblHeading = 'New Transport Association';
        this.btnActionLabel = 'Save';
        this.audit = this.utility.setAuditAttributes(this.now, this.user.LastName, this.now, this.user.LastName); 
      }


    });
   }


  initForm() {
    this.form = new FormGroup({
      id: new FormControl()
      , code: new FormControl(this.transportData.code, Validators.compose([Validators.required, <any>Validators.maxLength(12), Validators.pattern('[\\w\-\\s\\/]+')]))
      , description: new FormControl(this.transportData.description,Validators.compose([Validators.required, <any>Validators.maxLength(100)]))
      , group_code: new FormControl(this.transportData.group_code, Validators.compose([Validators.required, <any>Validators.maxLength(12)]))
      , sort_order: new FormControl(this.transportData.sort_code)
      , is_active: new FormControl()
      , display_ind: new FormControl(this.transportData.display_ind)
      , date_created: new FormControl()
      , date_modified: new FormControl()
      , user_created: new FormControl()
      , user_modified: new FormControl()
      , email: new FormControl(this.transportData.email,Validators.compose([Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]))
      , cellphone: new FormControl(this.transportData.cellphone,Validators.compose([Validators.required]))
      , telephone: new FormControl(this.transportData.telephone,Validators.compose([Validators.required]))
      //, fax: new FormControl(this.transportData.telephone)
      , alternative_cellphone: new FormControl(this.transportData.alternative_cellphone, Validators.compose([Validators.required]))
      , alternative_email: new FormControl(this.transportData.alternative_email, Validators.compose([Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]))

    });
    this.form.patchValue(this.utility.defaults);
    
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
  ChangeCountry(event){
    //console.log(event);
    this.defaultCountry = event.iso2;
  }
  ChangeCountryPhone(event){
    this.defaultCountryPhone = event.iso2;
  
  }

  onSubmit(obj: any) {
    //console.log(obj)
    if (this.isDup) { return; }
    this.transportData = obj;
    this.message = (this.isEdit) ? "Updating Transport Association..." : "Adding a new Transport Association...";
    if (this.isEdit) {
      this.transportData.date_modified = new Date();
      this.transportData.user_modified = this.user.LastName;
    
    this.transportData.iso2_cell = this.defaultCountry;
    this.transportData.iso2_tele = this.defaultCountryPhone;

    this.transportData.dial_code_cell = obj.cellphone.dialCode
    this.transportData.cellphone = obj.cellphone.number
    this.transportData.dial_code_tele = obj.telephone.dialCode
    this.transportData.telephone = obj.telephone.number
    this.transportData.email = this.transportData.email.toLowerCase();
    this.transportData.alternative_email = this.transportData.alternative_email.toLowerCase();
    //console.log(this.transportData);




      this.isLoading = true;
      this.service.update(this.transportData).subscribe(result => {
        this.transportData = result;
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComponent, { title: 'UpdateTransport Association', message: `Transport Association ${this.transportData.code} updated succesfully.`, bold: `${this.transportData.code}` });
        this.toastService.success(`Transport Association ${this.transportData.code} updated succesfully.`,'UpdateTransport Association');
        this.navigate();
      }, error => {
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComponent, { title: `Transport Association`, message: `Failed to update Transport Association with ${this.transportData.code}.Please contact the system administrator if the problem persists.`, bold: `${this.transportData.code}` });
        this.toastService.error(`Failed to update Transport Association with ${this.transportData.code}.Please contact the system administrator if the problem persists.`,'UpdateTransport Association')

      });
    } else {
      this.transportData.date_modified = this.transportData.date_created = new Date();
      this.transportData.user_modified = this.transportData.user_created = this.user.LastName;
      this.transportData.iso2_cell = this.defaultCountry;
      this.transportData.iso2_tele = this.defaultCountryPhone;
  
      this.transportData.dial_code_cell = obj.cellphone.dialCode
      this.transportData.cellphone = obj.cellphone.number
      this.transportData.dial_code_tele = obj.telephone.dialCode
      this.transportData.telephone = obj.telephone.number
      this.transportData.email = this.transportData.email.toLowerCase();
      this.transportData.alternative_email = this.transportData.alternative_email.toLowerCase();
      
      //console.log(this.transportData);

      this.isLoading = true;     
      this.service.add(this.transportData).subscribe(result => {
        this.transportData = result;
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComponent, { title: 'New Transport Association', message: `New Transport Association ${this.transportData.code} added successfully.`, bold: `${this.transportData.code}` });
        this.toastService.success(`New Transport Association ${this.transportData.code} added successfully.`,'New Transport Association');
        this.navigate();
      }, error => {
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComponent, { title: `New Transport Association`, message: `Failed to add Transport Association with ${this.transportData.code}.Please contact the system administrator if the problem persists.`, bold: `${this.transportData.code}` });
        this.toastService.error(`Failed to add Transport Association with ${this.transportData.code}.Please contact the system administrator if the problem persists.`,'New Transport Association');

      });
    }
  }

  navigate() {
    this.router.navigateByUrl('/transport/association/list');
  }



  onChanges(): void {
    this.form.get('code').valueChanges.subscribe(code => {

      if (code.length > 3) {
        this.service.checkByCode(code.trim()).subscribe((result:any) => {
          this.isDup = (result.Status && !this.isEdit) ? true : false;
        }, error => {
          this.isDup = false;

        });
      }
    });
  }

  onSelectChange() {
    console.dir(this.selectedDisplay);
  }

}
